import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    title: obj?.title,
    category: obj?.category,
    icon: obj?.icon,
    image: obj?.image,
    imageAlt: obj?.image_alt,
    description: obj?.description,
    fullDescription: obj?.full_description,
    features: obj?.features || [],
    deliveryTime: obj?.delivery_time,
    startingPrice: obj?.starting_price,
    basePrice: obj?.base_price,
    industries: obj?.industries || [],
    businessSizes: obj?.business_sizes || [],
    stats: obj?.stats,
    color: obj?.color,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

const toSnakeCase = (obj) => {
  return {
    title: obj?.title,
    category: obj?.category,
    icon: obj?.icon,
    image: obj?.image,
    image_alt: obj?.imageAlt,
    description: obj?.description,
    full_description: obj?.fullDescription,
    features: obj?.features,
    delivery_time: obj?.deliveryTime,
    starting_price: obj?.startingPrice,
    base_price: obj?.basePrice,
    industries: obj?.industries,
    business_sizes: obj?.businessSizes,
    stats: obj?.stats,
    color: obj?.color,
  };
};

export const serviceService = {
  async getAll() {
    const { data, error } = await supabase?.from('services')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return data?.map(toCamelCase) || [];
  },

  async getById(id) {
    const { data, error } = await supabase?.from('services')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async create(service) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('services')?.insert({ ...toSnakeCase(service), created_by: user?.id })?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async update(id, service) {
    const { data, error } = await supabase?.from('services')?.update(toSnakeCase(service))?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async delete(id) {
    const { error } = await supabase?.from('services')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  subscribeToChanges(callback) {
    const channel = supabase?.channel('services')?.on('postgres_changes', { event: '*', schema: 'public', table: 'services' }, (payload) => {
        callback(payload);
      })?.subscribe();

    return () => supabase?.removeChannel(channel);
  },
};
